import { useMutation } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useCallback, useEffect } from "react";

import { PageHeader } from "@/components/layout/heading";
import { BrandIntelligenceGrid } from "@/components/brand-intelligence/brand-intelligence-grid";

import { useSession } from "@/hooks/use-session";
import { useStreamingResponse } from "@/hooks/use-streaming-response";
import { useAuthenticationStore } from "@/store/authentication";

import { ProfileApiFactory } from "@/apis/profile";
import { ResearchApiFactory } from "@/apis/research";

export const Route = createFileRoute("/dashboard/research/_layout/$id")({
  component: ResearchIdLayout,
});

function ResearchIdLayout() {
  return <Outlet />;
}

export function ResearchIdRouteComponent() {
  const session = useSession();
  const company = session.profile.company;
  const setCompanyProfile = useAuthenticationStore((state) => state.setCompanyProfile);

  const { mutate: fetchCompanyProfile } = useMutation({
    mutationFn: ProfileApiFactory.Apis.FetchCompanyProfile,
  });

  const onStreamSuccess = useCallback(() => {
    fetchCompanyProfile(void 0, {
      onSuccess: (response) => {
        setCompanyProfile(response.data);
      },
    });
  }, [fetchCompanyProfile, setCompanyProfile]);

  const [, { handleStreamSuccess, handleStreamError }] = useStreamingResponse({
    messages: company.brand_research_metadata || [{ id: company.brand_research_session_id!, type: "ai", message: [], streaming: true }],
    onStreamSuccess,
  });

  const { mutate: consumeStream } = useMutation({
    mutationFn: () => {
      return ResearchApiFactory.Apis.ConsumeBrandResearch(company.brand_research_session_id!);
    },
  });

  useEffect(() => {
    if (!company.brand_research_session_id || company.brand_research_status === "completed") {
      return;
    }

    consumeStream(void 0, {
      onSuccess: (body) => {
        handleStreamSuccess(body, company.brand_research_session_id!, company.brand_research_metadata);
      },
      onError: () => {
        handleStreamError(company.brand_research_session_id!);
      },
    });
  }, [company.brand_research_session_id, company.brand_research_status, company.brand_research_metadata, consumeStream, handleStreamSuccess, handleStreamError]);

  return (
    <section id="brand-research">
      <PageHeader title="Brand Research" description="Combining deep brand knowledge with market insights to apply rich, relevant context to every creative output.">
        {/* <div className="flex flex-col items-start sm:flex-row sm:items-center gap-2">
          <Tabs value={tab} onValueChange={setTab}>
            <TabsList className="bg-primary-foreground">
              {["audience", "competitor-analysis", "performance"].map((tab) => (
                <TabsTrigger key={tab} value={tab} className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground sm:px-6">
                  {tab.split("-").map(upperFirst).join(" ")}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs> 
          <Drawer.Root direction="right" open={stepsSidebarOpen} onOpenChange={setStepsSidebarOpen}>
            <Drawer.Trigger asChild>
              <Button variant="outline" size="sm" className="text-xs">
                Show Steps
              </Button>
            </Drawer.Trigger>
            <Drawer.Portal>
              <Drawer.Overlay className="fixed inset-0 bg-black/40 dark:bg-black/80 backdrop-blur-xs z-50" />
              <Drawer.Content className="right-0 top-0 bottom-0 mt-8 w-full sm:max-w-3xl sm:mt-0 sm:right-2 sm:top-2 sm:bottom-2 fixed z-50 outline-none flex" style={mDrawerStyle}>
                <Drawer.Close asChild>
                  <Button variant="outline" size="icon" className="absolute top-4 right-4 z-50">
                    <X className="size-4" />
                  </Button>
                </Drawer.Close>
                <Drawer.Title className="sr-only">Brand Research Steps</Drawer.Title>
                <Drawer.Description className="sr-only">Research steps for {company.organization_id}</Drawer.Description>
                <DrawerContent />
              </Drawer.Content>
            </Drawer.Portal>
          </Drawer.Root>
        </div> */}
      </PageHeader>
      <div className="mt-8">
        <BrandIntelligenceGrid />
      </div>
    </section>
  );
}
